var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMusic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_90",
    "data-name": "Groupe 90",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.042,
    height: 30.641,
    viewBox: "0 0 26.042 30.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_184",
    "data-name": "Trac\\xE9 184",
    d: "M10.3,15.712c0,1.854-2.083,3.356-4.65,3.356S1,17.566,1,15.712s2.083-3.356,4.65-3.356S10.3,13.859,10.3,15.712Zm16.741-3.356c0,1.854-2.083,3.356-4.65,3.356s-4.65-1.5-4.65-3.356S19.825,9,22.392,9,27.042,10.5,27.042,12.356Z",
    transform: "translate(-1 11.573)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_185",
    "data-name": "Trac\\xE9 185",
    d: "M21.915,22.191V2h1.879V22.191ZM6.879,4.243V26.678H5V4.243Z",
    transform: "translate(2.03 1)",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_186",
    "data-name": "Trac\\xE9 186",
    d: "M5,5.074A2.1,2.1,0,0,1,6.692,2.88L21.727,1.116a1.711,1.711,0,0,1,1.449.559,2.393,2.393,0,0,1,.619,1.635V5.284L5,7.489Z",
    transform: "translate(2.03 -1.105)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic);
export default __webpack_public_path__ + "static/media/icon-music.0a52128e6632bc5bee123cc2b9c25673.svg";
export { ForwardRef as ReactComponent };